(function (Drupal, once, duo) {
  Drupal.behaviors.accordion = {
    selector: '[data-accordion]',

    attach: function attach() {
      const accordions = document.querySelectorAll(this.selector);

      if (!accordions) {
        return;
      }

      accordions.forEach((accordion) => {
        if (!accordion.classList.contains('accordion-applied')) {
          new duo.Accordion(accordion);
          accordion.classList.add('accordion-applied');
        }
      });
    },
  };
})(Drupal, once, window.duo = window.duo || {});
